import bn from "bignumber.js";

export const ethersToBN = (ethersBN) => {
    return new bn(ethersBN.toString());
}